var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service_box safe-distance-top-header-two"},[_c('Header',{attrs:{"pageTitle":_vm.$route.meta.title}}),_c('keep-alive',{attrs:{"include":_vm.keepAlive}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }